
import MessageLoading from '../../../../component/view/message_loading/';
import activity from './activity';
import log from '../../../../lib/log';
import parser from './parser';
import { getTranslation } from '../../../../utils';

export default class Robot {
  constructor(app) {
    this.app = app;
    /**
     * 访客版，传了encryptedUserId之后，后续都用新值
     * @type {string}
     */
    this.encryptedUserId = '';
    /**
     * 直连的bizType,需要传给机器人
     * @type {null}
     */
    this.bizType = null;
    /**
     * 聊天的顺序，从1开始
     * @type {Number}
     */
    this.chatSequence = 0;
    /**
     * 地理位置信息
     * @type {null}
     */
    this.pos = null;
    /**
     * 设备信息
     * @type {null}
     */
    this.deviceInfo = null;
    /**
     * 选择的订单Id
     * 用于自助卡片带入订单号需求
     * TODO:推动鬼宿改自助卡片实现方式
     * @type {number}
     */
    this.orderId = 0;
    /**
     * 调机器人传的subType
     * eg: 'text';'image';'order';'item';'postorder';'connect'
     */
    this.subType = null;

    /**
     * 用户问题的问题
     * @type {String}
     */
    this.question = '';
    /**
     * 问的问题列表，用户停止输入则一起发送
     */
    this.questionList = [];
    /**
     * 是否进入了SOP流程
     */
    this.isInSOP = false;
    /**
     * 知识展示次数,大于配置次数则展示转人工入口
     * @type {number}
     */
    this.count = 0;
    /**
     * 通过知识点转人工的阈值
     * @type {number}
     */
    this.threshhold = this.__getThreshhold();
    // this.__getLocation();
    // this.__getDeviceInfo();
    const liveAgent = getTranslation('csc.shortcut.liveagent');
    this.liveAgentCode = [{ code: 'liveAgent', icon: 'service', text: liveAgent, type: 'text', title: liveAgent, content: liveAgent }];
    this.shortcuts = this.liveAgentCode.concat(app.essentials.config.config.shortcuts || []);
    this.isFirstMessage = true;
  }

  /**
   * 机器人上线
   */
  online() {
    const app = this.app;
    app.view.setReceiver((data, type, show, post) => {
      this.call(data, type, show, post);
    });
    app.emit(app.events.CHANNEL_ROBOT_ONLINE);
  }

  /**
   * 用户输入
   */
  call(data, type, show, post) {
    // 展示用户输入
    if (show) {
      // const question = util.isObject(data) && type !== 'order' ? data.q : data;
      this.showConsumerMessage(data, type);
      if (this.isFirstMessage) {
        this.app.util.goldlog('USER_SEND_FIRST_MESSAGE_TO_CHATBOT');
        this.isFirstMessage = false;
      }
    }
    // 前端直接拦截处理的数据
    if (activity(this.app, data.q ? data.q : data)) {
      return;
    }
    // 获取机器人答案
    if (post) {
      setTimeout(() => {
        this.showMessageLoading();
      }, 0);
      this.post(data, type);
    }
  }

  post(data, type) {
    const { appId } = this.app.param;
    // let isRaR = false;
    // if (data === 'refund status') {
    //   isRaR = true;
    // }
    const param = this.getParams(data, type);
    this.getData({
      message: JSON.stringify(param),
      appId,
    });
  }

  getParams(data, type) {
    const config = this.app.appConfig;
    const base = config.get('base');
    const appConfig = config.get('appConfig');
    const tenantId = config.get('qs').tenantId || 3;
    const user = config.get('user');
    const { robotCode, robotScene, botId } = config.get('robot');
    const { chatOptions: { language } } = this.app;

    // let module = '';
    // const ext = '';
    let q = data;
    let subType = type;

    // 聊天轮次+1
    this.chatSequence += 1;

    /**
     * data为object的时候
     * q: 用户发的内容
     * header: 自定义header内容
     * subType：发送内容的子类型
     */
    if (typeof data === 'object') {
      q = data.q;
      subType = data.subType;
      // 访客版，传了encryptedUserId之后，后续都用新值
      if (data.encryptedUserId) {
        this.encryptedUserId = data.encryptedUserId;
      }
    }
    // 有设置subType，优先使用，且仅使用一次
    if (this.subType) {
      subType = this.subType;
      // 第二次subType按正常逻辑
      this.subType = null;
    }

    // 发图片，转一下格式
    if (type === 'image') {
      q = JSON.stringify({ url: q });
    }

    this.question = q;
    const param = {
      header: {
        querystring: config.get('qs'),
        memberType: config.get('user').memberType,
        from: base.from,  // 页面来源
        imsid: this.app.param.imSid || base.imsid, // 会话的唯一sid
        appName: appConfig.appName || 'alixm',
        chatSequence: this.chatSequence,
        msglog: 3, // 是否存历史消息：0/1/2/3表示  不存/存提问/存答案/都存
        sessionId: '', // 用来区分机器人和人工的，机器人传空
        bu: config.get('base').bu, // 知识维度
        bizType: this.bizType, // 来自维权等页面，把bizType带到机器人
        // module, // 直接定位到机器人模块，比如天气 机票的处理
        showType: '', // 展示方式，仅仅用来恢复历史消息，呵呵 = =（物流单号需求，取物流信息 根据type=mailno id=订单id取数据）
        sceneCode: robotScene,
        robotCode,
        botId,
        qType: subType || 'text', // 取值text,image,order,item,postorder
        encryptedUserId: this.encryptedUserId,
        tenantId, // 租户用，从querystring里取，默认为3
      },
      type: subType || 'text', // 发送的消息类型，默认为文本，以后可能有语音
      subType,
      body: q,
      fromId: user.userId,
      fromName: user.nick,
    };


    // 给orderId赋值,用于自助卡片,带入订单号
    if (subType === 'order') {
      this.orderId = q;
    }
    // 经纬度
    if (this.pos) {
      param.header = Object.assign(param.header, this.pos);
    }
    // 设备信息
    if (this.deviceInfo) {
      param.header = Object.assign(param.header, this.deviceInfo);
    }
    // 活动需要的code，从querystring里取
    if (config.code) {
      param.header.code = config.code;
    }
    // 是否是直连人工
    if (config.isConnect) {
      param.header.orderSelectSource = 'directConnect';
    }

    // 额外参数，除了question，其他业务上要用的额外数据，以后都用这个，别再加字段了= =
    param.header.ext = {
      vendorParam: JSON.stringify({
        LOCALE: language,
      }),
    };
    if (typeof data === 'object') {
      if (data.ext) {
        param.header.ext = {
          ...param.header.ext,
          ...data.ext,
        };
      }
      // 有传header，直接assign进来
      if (data.header) {
        param.header = Object.assign(param.header, data.header);
      }
    }
    return param;
  }

  getData(data) {
    this.__resetUITestClass();
    // 展示 loading 气泡，加点延迟，避免和用户气泡同时出现，显得更流畅 = =
    this.app.model.openair(data).then((res) => {
      // 解析数据
      setTimeout(() => {
        // if (data.isRaR) {
        //   this.parseOpenair([
        //     {
        //       type: 'ack',
        //     },
        //     {
        //       header: {
        //         sessionId: 'd876504844da4c8dacdc4ef6c06f3bcf',
        //         appId: 4,
        //         tenantId: 1,
        //         senderType: 4,
        //         appName: 'alixm',
        //         chatUuid: '17de9df9375b4085bd100a8eec884632',
        //       },
        //       subType: 'text',
        //       type: 'returnAndRefundList',
        //       body: '{\"action\":{\"intentName\":\"ReturnAndRefund_Start\",\"parameters\":{\"Page\":[\"2\"]}},\"orders\":[{\"redirectUrl\":\"https://my.lazada.co.id/customer/returns/view/?spm=a2o42.myreturn.0.0.37177a93myV11Z&requestType=return&reverseOrderId=213313000328899\",\"detailUrlParams\":{\"requestType\":\"return\",\"reverseOrderId\":\"213313000328899\"},\"packages\":[{\"button\":{\"action\":{\"intentName\":\"ReturnAndRefund_AskFeedBack\"}},\"request_time\":\"Juli 26 2019\",\"ra_no\":\"213313000328899\",\"title\":\"Return to lazada\",\"items\":[{\"image\":\"https://id-live-02.slatic.net/p/576b645b2cd71b3667142eef4d3534c2.jpg\",\"return_reason\":\"Change of mind\",\"return_amount\":\"Rp7.434\",\"quantity\":1,\"price\":\"Rp7.434\",\"title\":\"test product upo\",\"status\":\"Mulai Pengembalian Barang\"},{\"image\":\"https://id-live-02.slatic.net/p/576b645b2cd71b3667142eef4d3534c2.jpg\",\"return_reason\":\"Change of mind\",\"return_amount\":\"Rp7.433\",\"quantity\":1,\"price\":\"Rp7.433\",\"title\":\"test product upo\",\"status\":\"Mulai Pengembalian Barang\"},{\"image\":\"https://id-live-02.slatic.net/p/576b645b2cd71b3667142eef4d3534c2.jpg\",\"return_reason\":\"Change of mind\",\"return_amount\":\"Rp7.433\",\"quantity\":1,\"price\":\"Rp7.433\",\"title\":\"test product upo\",\"status\":\"Mulai Pengembalian Barang\"}]}]},{\"redirectUrl\":\"https://my.lazada.co.id/customer/returns/view/?spm=a2o42.myreturn.0.0.37177a93myV11Z&requestType=return&reverseOrderId=213547300328899\",\"detailUrlParams\":{\"requestType\":\"return\",\"reverseOrderId\":\"213547300328899\"},\"packages\":[{\"button\":{\"action\":{\"intentName\":\"ReturnAndRefund_AskFeedBack\"}},\"request_time\":\"Juli 26 2019\",\"ra_no\":\"213547300328899\",\"title\":\"Return to lazada\",\"items\":[{\"image\":\"https://id-live-02.slatic.net/p/576b645b2cd71b3667142eef4d3534c2.jpg\",\"return_reason\":\"Change of mind\",\"return_amount\":\"Rp8.600\",\"quantity\":1,\"price\":\"Rp8.600\",\"title\":\"test product upo\",\"status\":\"Pengembalian dana tertunda\"}]}]}]}',
        //       fromId: 119,
        //       fromName: 'robot',
        //       toId: '1000001000417720',
        //       toName: '3fdea2d32f1de7cf30acc8f91531d0a59b04da37',
        //     },
        //   ]);
        // } else this.parseOpenair(res);
        this.parseOpenair(res);
      }, 200);
      // 无答案内容返回
      if (res.length < 2) {
        this.getDataException();
      }
    }, (err) => {
      this.getDataException(data, err);
    });
  }

  getDataException() {
    // console.log(err);
    // 请求失败需要移除气泡
    this.app.view.body.scrollToBottom();
    this.app.appendSystemMessage(this.app.util.lang.get('ROBOT:EXCEPTION'));
    this.hideMessageLoading();
    // TODO
    // this.loading.fail(err || err.message);
  }

  /**
   * 显示用户输入的消息
   * 用户输入没有异步，直接展示即可
   * 所以这里不需要加占位符
   */
  showConsumerMessage(data, type) {
    const app = this.app;
    let param = {};
    if (!type || type === 'text') {
      let q = data;
      if (app.util.isObject(data)) {
        q = data.q;
      }
      param = {
        type: 'consumer',
        body: {
          userId: 1,
          text: q,
          side: 'right',
          // 动画效果展示
          animate: true,
        },
      };
    } else {
      param = {
        type,
        body: {
          userId: 1,
          text: data,
          side: 'right',
          // 动画效果展示
          animate: true,
        },
      };
    }
    app.postMessage(param).then((ret) => {
      $('.m-chatpanel-item').removeClass('T_send');
      ret.body.addClass('T_send');
      app.view.body.append(ret.body);
    });
  }

  // 延时一段时间，如果用户没有操作则展现该消息
  lazyMessage(item) {
    let touched = false;
    let num = 0;
    const app = this.app;
    const limit = (item.body.lazy * 1000 + 300) / 100;
    // lazy消息一个session只出现一次
    if (this.lazyed) {
      return;
    }
    $(window).on('touchstart', () => {
      touched = true;
    });
    const timer = setInterval(() => {
      if (num === limit) {
        if (!touched) {
          const param = item.body;
          app.appendMessage({
            type: item.type,
            body: param,
          });
          this.lazyed = true;
        }
        clearInterval(timer);
      }
      num += 1;
    }, 100);
  }

  /**
   * 展示机器人消息
   * 因为有异步插件，为了保证消息展示顺序，先append占位符
   * @param data
   */
  showRobotMessage(data, showLoading) {
    const app = this.app;
    // t时间内用户没有操作，则显示的消息
    if (data.body && data.body.lazy) {
      this.lazyMessage(data);
      return;
    }
    // 向pipeline中push数据
    app.postMessage(data)
      .then((res) => {
        if (res && res.body) {
          switch (res.type) {
            case 'sop':
              this.hideMessageLoading();
              app.view.footer.showSlideUp(true);
              break;
            default:
              this.loading.load(res.body, res.isSlideUp);
              this.__setUITestClass(res.body);
              if (showLoading) {
                this.showMessageLoading();
              }
              break;
          }
        } else {
          this.hideMessageLoading();
        }
      }, () => {
        this.hideMessageLoading();
        app.appendMessage({
          type: 'system',
          body: {
            text: app.util.lang.get('ROBOT:EXCEPTION'),
          },
        });
        // this.loading.fail(err || err.message);
      });
  }

  /**
   * 展示气泡 loading
   */
  showMessageLoading() {
    const app = this.app;
    if (!this.loading) {
      this.loading = new MessageLoading(app.view);
    } else {
      // this.hideMessageLoading();
    }
    // 显示loading气泡
    this.loading.init();
  }

  hideMessageLoading() {
    setTimeout(() => {
      this.loading.remove();
    }, 0);
  }

  parseOpenair(data) {
    if (this.app.channel.curRole !== 'robot') {
      return;
    }
    const len = data.length;
    let shortcutTime = 0;
    data.forEach((item, index) => {
      ((t, i) => {
        // 间隔时间
        let time = (i - 1) * 1500 + 300;
        if (t.type === 'dynamic_shortcuts' || t.type === 'buttons' || item.lazy) {
          // 如果为快捷短语、按钮、lazy消息，间隔时间为上一个消息的时间
          time = Math.ceil((i - 2) * 1500 + 300, 0);
          // 快捷短语出现的时间设置
          if (!shortcutTime) {
            shortcutTime = time;
          }
        }
        item.question = this.question;
        const d = parser.run(this, item);
        if (d && d.type === 'empty') {
          // 空消息，隐藏加载
          setTimeout(() => {
            this.hideMessageLoading();
          }, 410);
        } else if (d && d.type && d.body) {
          setTimeout(() => {
            // 传mid参数，用于删除消息
            d.body.mid = item.id;
            d.body.__question__ = this.question;
            let showLoading = i < len - 1;
            // 最后一条消息，不加loading
            if (i < len - 1 && (data[i + 1].type === 'dynamic_shortcuts' || data[i + 1].lazy)) {
              showLoading = false;
            }
            this.showRobotMessage(d, showLoading);
            this.extraMessage(item);
          }, time);
        }
      })(item, index);
    });
    // 快捷短语显示处理
    setTimeout(() => {
      this.setShortcuts(data);
    }, shortcutTime);
  }
  /**
   * 根据返回字段需要显示额外消息的逻辑
   */
  extraMessage(item) {
    const config = this.app.appConfig;
    const base = config.get('base');
    try {
      if (item.type !== 'ack') {
        const body = JSON.parse(item.body);
        body.__question__ = this.question;
        // 换订单提示
        if (body.showChangeOrderTip) {
          this.app.appendMessage({
            type: 'system',
            body: {
              text: this.app.util.lang.get('KNOWLEDGE:CHANGEORDERTIP'),
            },
          });
        }
        if (body.extraParams && body.extraParams.orderSelectSource === 'command') {
          this.orderSelectSource = body.extraParams.orderSelectSource;
          if (body.extraParams.orderSelectSource === 'command'
            && ('alxm,zzb,fwzs,shezhi,tmall,tmall_mytmall').indexOf(base.from) >= 0) {
            this.app.appendMessage({
              type: 'buttons',
              body: {
                list: [{
                  text: '选择订单',
                  icon: 'bag',
                  action: 'selectOrder',
                  params: {
                    code: null,
                    content: null,
                  },
                }],
              },
            });
          }
        }
        // 反馈
        if (body.needFeedback) {
          body.originBody = item.body;
          this.app.appendMessage({
            type: 'feedback',
            body,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 设置快捷短语
   * 转人工和后端返回的快捷短语要合并
   * @param data
   * @private
  */
  setShortcuts(data) {
    let manualShortcuts = null;
    let robotShortcuts = null;
    data.forEach((item) => {
      try {
        // 如果需要展示转人工，给manualShortcuts赋值
        if (this.__shouldShowGomanual(item) && !this.app.shortcuts.agentHidden) {
          manualShortcuts = {
            isAdd: false,
            shortcuts: this.shortcuts || [],
          };
        }
      } catch (e) {
        // console.log(e);
      }
      // 如果机器人返回了动态快捷短语
      if (item.type === 'dynamic_shortcuts') {
        robotShortcuts = JSON.parse(item.body);
      }
    });

    // 合并之后的快捷短语
    const combinedShortcuts = this.__formatShortcutData(manualShortcuts, robotShortcuts);
    if (combinedShortcuts) {
      this.hideMessageLoading();
      setTimeout(() => {
        this.app.shortcuts.push(combinedShortcuts);
      }, 500);
    }
  }
  /**
   * 去掉页面现有的ui测试标
   */
  __resetUITestClass() {
    $('.bubble-up-from-left').removeClass('T_receive');
  }

  __setUITestClass($node) {
    if ($node) {
      $node.parent('.bubble-up-from-left').addClass('T_receive');
    }
  }

  __inputingLogic() {
    $(document).on('inputing', () => {
      // 2s内连续发送，放在数组里，2s之后统一发送
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.questionList.length > 0) {
          this.post(this.questionList.join('###'), 'text');
          this.questionList.length = 0;
        }
      }, 2000);
    });
  }

  /**
   * 合并机器人返回的动态快捷短语 和 前端自己逻辑生成的快捷短语（目前就是转人工）
   * @param {any} manualShortcuts
   * @param {any} robotShortcuts
   */
  __formatShortcutData(manualShortcuts, robotShortcuts) {
    let res = null;
    if (robotShortcuts && manualShortcuts) {
      res = manualShortcuts;
      res.shortcuts = res.shortcuts.concat(robotShortcuts.shortcuts);
    } else if (robotShortcuts) {
      res = robotShortcuts;
    } else if (manualShortcuts) {
      res = manualShortcuts;
    }
    return res;
  }

  /**
   * 是否需要展示转人工入口
   * @param {any} item
   */
  __shouldShowGomanual(item) {
    let shouldShow = false;
    if (item.header && item.header.chatUuid) {
      this.app.chatUuid = item.header.chatUuid;
    }
    const { shortcutsRoundNumber } = window.__alime__;
    if (item.type === 'knowledge' || item.type === 'recommend' || item.type === 'noanswer') {
      this.count += 1;
      /**
       * 如果展现知识点的次数大于阈值
       * 或者返回的参数里指定了showManual=true
       * 并且有返回技能组，那么都要展示转人工入口
       */
      if (this.count === shortcutsRoundNumber) {
        if (!this.app.shortcuts.agentHidden) {
          shouldShow = true;
          this.app.liveAgent = {
            entry: 'knowledge',
          };
          log.liveAgent({
            entry: 'knowledge',
            type: 'show',
            chatUuid: item.header.chatUuid,
            intent: '',
          });
        }
      } else if (this.count > shortcutsRoundNumber) {
        this.app.view.footer.showShortcuts();
      }
    }
    return shouldShow;
  }


  /**
   * 获取知识点转人工阈值
   * @param type default,sop
   * @returns {number}
   * @private
   */
  __getThreshhold(type = 'default') {
    let threshhold = 0;
    const app = this.app;
    const switches = app.appConfig.get('switches') || {};
    const knowledgeToManual = switches && switches.knowledgeToManual;
    if (knowledgeToManual && knowledgeToManual.enable) {
      if (type === 'default') {
        threshhold = knowledgeToManual.threshhold || 0;
      } else if (type === 'sop') {
        threshhold = knowledgeToManual.sopthreshhold || 0;
      }
    }
    return threshhold;
  }

  /**
   * 获取地理位置信息
   * @private
   */
  __getLocation() {
    const pos = {};
    const bridge = this.app.bridge;
    if (bridge.detect('getLocation')) {
      bridge.getLocation().then((res) => {
        pos.longitude = res.longitude;
        pos.latitude = res.latitude;
        this.pos = pos;
      });
    }
  }

  /**
   * 获取设备信息
   * @private
   */
  __getDeviceInfo() {
    const deviceInfo = {};
    const bridge = this.app.bridge;
    if (bridge.detect('getDeviceInfo')) {
      bridge.getDeviceInfo().then((res) => {
        deviceInfo.deviceId = res.deviceID;
        deviceInfo.model = res.model;
        this.deviceInfo = deviceInfo;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/context/channel/robot/index.js